export const convertObjectKeysFromKebabCaseToCamelCase = (obj: { [key: string]: any }) => {
  const newObj: { [key: string]: any } = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const camelCaseKey = key.replace(/([-_]\w)/g, g => g[1].toUpperCase());
      newObj[camelCaseKey] = obj[key];
    }
  }
  return newObj;
};
